<template>
<div class="chapter">
<div class="inner_page">
<p class="txc" id="d6e1566">For all the people who told me they loved Tejada<br/>and wanted me to reform him,<br/>and all the people who hated Tejada<br/>and begged me to kill him off in the last book.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Pawe_9781569477786_epub_c6_r1.vue?081d8994